import { render } from 'preact';
import { QuarterSocialApp } from '../components/quarterSocial/QuarterSocialApp.jsx';
import '../styles/quarter-social.css';

const root = document.getElementById('pp-quarter-social-root');

if (root) {
  root.innerHTML = '';
  render(<QuarterSocialApp root={root} />, root);
}

